import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import { CheckboxGroup } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { Field, initialize, reduxForm } from "redux-form"
import { assignPermission, getAdminRoles, getPermissions } from "store/actions"

const Permissions = ({
  getPermissions,
  permissions,
  getAdminRoles,
  adminRoles,
  initializeForm,
  handleSubmit,
  loading,
  assignPermission,
}) => {
  useEffect(() => {
    getPermissions()
    getAdminRoles()
  }, [])

  useEffect(() => {
    if (permissions?.length > 0) {
      let perms = {}
      permissions?.forEach(permission => {
        perms = {
          ...perms,
          [permission?.id]: {
            id: permission?.id,
            roles: permission?.roles?.map(role => role?.id),
            name: permission?.name,
            description: permission?.description,
          },
        }
      })
      initializeForm({ permissions: perms })
    }
  }, [permissions])

  const handleSave = data => {
    let preparedData = {}
    for (const permission in data?.permissions) {
      let roles = {}
      adminRoles?.forEach(role => {
        roles = {
          ...roles,
          [role?.id]: data?.permissions[permission]?.roles?.includes(role?.id),
        }
      })
      preparedData = {
        ...preparedData,
        [permission]: {
          ...data?.permissions[permission],
          roles: roles,
        },
      }
    }
    assignPermission({ permissions: preparedData })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Permissions" />
        <Container fluid>
          <BreadcrumbTitle
            title="Permissions"
            breadcrumbItems={[{ title: "Dashboard" }, { title: "Permissions" }]}
          />
          <Card>
            <CardBody>
              {permissions?.length > 0 && adminRoles?.length > 0 && (
                <>
                  {permissions?.map(permission => {
                    return (
                      <Row className="my-4" key={permission?.id}>
                        <Col xs={12} md={7} xl={3}>
                          <Row>
                            <Col>
                              <h5>{permission?.name}</h5>
                            </Col>
                          </Row>
                          <Row>
                            <Col>{permission?.description}</Col>
                          </Row>
                        </Col>
                        <Col className="mt-2 d-xl-flex flex-wrap">
                          <Field
                            name={`permissions.${permission?.id.toString()}.roles`}
                            component={CheckboxGroup}
                            options={adminRoles.map(role => ({
                              value: role.id,
                              label: role?.name,
                            }))}
                          />
                        </Col>
                      </Row>
                    )
                  })}
                  <Row className="d-flex justify-content-center">
                    <Col xs="auto">
                      <SaveButton
                        type="button"
                        content="Save"
                        onClick={handleSubmit(handleSave)}
                        loading={loading}
                      />
                    </Col>
                  </Row>
                </>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = state => ({
  permissions: state.Permissions.permissions,
  adminRoles: state.Roles.adminRoles,
  loading: state.Permissions.loading,
})

const mapDispatchToProps = dispatch => ({
  getPermissions: values => dispatch(getPermissions(values)),
  getAdminRoles: values => dispatch(getAdminRoles(values)),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.PERMISSIONS, values)),
  assignPermission: values => dispatch(assignPermission(values)),
})

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(reduxForm({ form: FORM_NAMES.PERMISSIONS })(Permissions))
